import { render, staticRenderFns } from "./TiposActiviades.view.vue?vue&type=template&id=17929efc&scoped=true"
import script from "./TiposActiviades.view.vue?vue&type=script&lang=js"
export * from "./TiposActiviades.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17929efc",
  null
  
)

export default component.exports